import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {ProductVariant} from './model';

export interface ProductVariantState extends EntityState<ProductVariant> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ProductVariant' })
export class Store extends EntityStore<ProductVariantState> {

  constructor() {
    super();
  }

}
